module.exports = __webpack_public_path__ + "static/media/tom.a653deb4.wav";